var EmailItemBase = require("./EmailItemBase");

var EmailItem = xClass("EmailItem", EmailItemBase, function () {
    return cc.CSLoader.createNode("cocos/mail_mail_gift.csb");
})

EmailItem.prototype.ctor = function () {
    var self = this;
    EmailItemBase.prototype.ctor.call(self);
}
EmailItem.prototype.initData = function (data) {
    let self = this;
    EmailItemBase.prototype.initData.call(self, data);
    self.refreshUI(data);
}

EmailItem.prototype.refreshUI = function (data) {
    let self = this;
    //
    const hasOpen = data.openFlag == 1;
    self.received.setVisible(hasOpen);
    self.unreceive.setVisible(!hasOpen);
    //
    const hasDeletable = data.deletableFlag == 1;
    self.mask.setVisible(hasDeletable);
    //
    self.status_gift.setVisible(data.acceptFlag != 1);

    self.btn.setVisible(!hasDeletable);
    // self.btnText.setString("领取");
    if (!data.expireTs) {
        self.title.y = 50;
    } else {
        self.title.y = 75.8;
    }
}

EmailItem.prototype.onClick = function () {
    let self = this;
    EmailItemBase.prototype.getMailInfo.call(self, () => {
        self.openDetailPanel();
    }, () => {
        self.EmailMgr.isBusy = false;
    })
    //
    self.EmailMgr.dcSimple("page_click", {
        click_type: "message",
        session: self.EmailMgr.dcSession,
        sub_id: self.data.mailId,
        type: self.EmailMgr.getDctype(self.data),
        s_time: self.EmailMgr.getDcSTime(self.data.expireTs),
    });
}

EmailItem.prototype.onClickAccept = function () {
    let self = this;
    self.onClick();
}

EmailItem.prototype.openDetailPanel = function () {
    let self = this;
    self.EmailMgr.openDetailPanel(self.data, () => {
        self.EmailMgr.isBusy = false;
    }, () => {
        self.initData(self.data);
        // self.EmailMgr.refreshMails();
    });
}

module.exports = EmailItem;
